import * as constants from './constants';

const defaultState = {
    venueInfo: [],
};
export default (state = defaultState, action) => {
    switch (action.type) {
        case constants.VENUE_DETAIL:
            return {...state, venueInfo: action.value};
        default:
            return state;
    }
}